export const QUIZ_ANSWER_CREATE_REQUEST = 'QUIZ_ANSWER_CREATE_REQUEST'
export const QUIZ_ANSWER_CREATE_SUCCSESS = 'QUIZ_ANSWER_CREATE_SUCCSESS'
export const QUIZ_ANSWER_CREATE_FAIL = 'QUIZ_ANSWER_CREATE_FAIL'
export const QUIZ_ANSWER_CREATE_REST = 'QUIZ_ANSWER_CREATE_REST'

export const QUIZ_ANSWER_MY_LIST_REQUEST = 'QUIZ_ANSWER_MY_LIST_REQUEST'
export const QUIZ_ANSWER_MY_LIST_SUCCSESS = 'QUIZ_ANSWER_MY_LIST_SUCCSESS'
export const QUIZ_ANSWER_MY_LIST_FAIL = 'QUIZ_ANSWER_MY_LIST_FAIL'

export const QUIZ_ANSWER_LIST_REQUEST = 'QUIZ_ANSWER_LIST_REQUEST'
export const QUIZ_ANSWER_LIST_SUCCSESS = 'QUIZ_ANSWER_LIST_SUCCSESS'
export const QUIZ_ANSWER_LIST_FAIL = 'QUIZ_ANSWER_LIST_FAIL'
